import {
  ProgressNotfierActions,
  ProgressNotfierActionTypes,
} from './ProgressNotifierContext.types';
import { ProgressNotifierItemData } from './components/ProgressNotifier';

export const ProgressNotifierReducer = (
  state: ProgressNotifierItemData[],
  action: ProgressNotfierActions,
): ProgressNotifierItemData[] => {
  switch (action.type) {
    case ProgressNotfierActionTypes.DISPATCH_NOTIFCATION:
      return [...state, { ...action.payload }];
    case ProgressNotfierActionTypes.DISPATCH_NOTIFCATIONS:
      return [...state, ...action.payload];
    case ProgressNotfierActionTypes.REMOVE_NOTIFICATION:
      return state.filter((item) => item.id !== action.payload.id);
    case ProgressNotfierActionTypes.REMOVE_NOTIFICATIONS:
      return state.filter((item) => !action.payload.ids.includes(item.id));
    case ProgressNotfierActionTypes.UPDATE_NOTIFICATION:
      return state.map((x) => {
        if (x.id === action.payload.id) {
          if (action.payload.item.isError !== undefined) {
            x.isError = action.payload.item.isError;

            if (action.payload.item.errorMessage !== undefined) {
              x.errorMessage = action.payload.item.errorMessage;
            }
          } else if (action.payload.item.isSuccess !== undefined) {
            x.isSuccess = action.payload.item.isSuccess;
          } else if (action.payload.item.isWarning !== undefined) {
            x.isWarning = action.payload.item.isWarning;
            if (action.payload.item.warningMessage !== undefined) {
              x.warningMessage = action.payload.item.warningMessage;
            }
          }

          if (action.payload.item.label !== undefined) {
            x.label = action.payload.item.label;
          }
        }
        return x;
      });
    default:
      return { ...state };
  }
};
